import React from "react";

export const Wordmark = ({ className = "" }) => (
  <a
    href="/#home"
    className={`group inline-flex items-center gap-2.5 ${className}`}
    data-testid="brand-wordmark"
    aria-label="Mackbe Tech home"
  >
    <span className="relative inline-flex h-7 w-7 items-center justify-center">
      <span className="absolute inset-0 rounded-md border border-white/15 bg-gradient-to-br from-[#0A66FF] to-[#00D4FF]/40" />
      <span className="absolute inset-[3px] rounded-[5px] bg-[#07111F]" />
      <span className="relative font-display text-[13px] font-semibold tracking-tight text-white">
        M
      </span>
      <span className="absolute -right-0.5 -top-0.5 h-1.5 w-1.5 rounded-full bg-[#00D4FF] shadow-[0_0_8px_rgba(0,212,255,0.8)]" />
    </span>
    <span className="font-display text-[17px] font-medium tracking-tight text-white">
      Mackbe<span className="text-white/60"> Tech</span>
    </span>
  </a>
);

export default Wordmark;
